export {
  DEGRADED_STATIC_NETWORK_MS,
  getStaticNetworkHealth,
  reportStaticNetworkFailure,
  reportStaticNetworkSuccess,
  resetStaticNetworkHealthForTests,
  subscribeToStaticNetworkHealth,
  type StaticNetworkHealth,
} from "#static-data-health";
